var h = Object.defineProperty;
var o = (u, t, e) => t in u ? h(u, t, { enumerable: !0, configurable: !0, writable: !0, value: e }) : u[t] = e;
var p = (u, t, e) => o(u, typeof t != "symbol" ? t + "" : t, e);
import { BlocksDocument as y } from "./blocks-document.js";
import { BLOCK_TYPES as i, NO_MARGIN_CLASS as m, HORIZONTAL_RULE_FALLBACK as z, DEFAULT_ALIGNMENT as A } from "./constants.js";
import { TextSerializer as n } from "./text-serializer.js";
import { escape as f } from "./utils/escape.js";
class C {
  constructor(t, e) {
    p(this, "config");
    p(this, "schema");
    this.config = t, this.schema = e;
  }
  serialize(t) {
    if (t.type.name !== "doc")
      throw new Error("Must provide an entire document to serialize");
    return this.serializeFragment(t.content);
  }
  serializeSlice(t) {
    return this.serializeFragment(t.content);
  }
  serializeFragment(t) {
    let e = [];
    return t.forEach((s) => {
      let r = this.serializeBlock(s);
      r && e.push(r);
    }), new y(e);
  }
  serializeBlock(t) {
    switch (t.attrs.type) {
      case i.PARAGRAPH:
      case i.HEADING:
      case i.SUBHEADING:
      case i.SUBHEADING3:
      case i.SUBHEADING4:
      case i.SMALL:
      case i.CODE:
        return this.serializeTextBlock(t);
      case i.IF_ELSE_STATEMENT:
        return this.serializeIfElseStatement(t);
      case i.IMAGE:
        return this.isIncompleteUpload(t.attrs.src) ? void 0 : this.serializeAsImage(t);
      case i.IMAGE_TEXT:
        return this.serializeAsImageText(t);
      case i.ORDERED_LIST:
      case i.UNORDERED_LIST:
        return this.serializeAsList(t);
      case i.VIDEO:
        return this.serializeAsVideo(t);
      case i.VIDEO_FILE:
        return this.serializeAsVideoFile(t);
      case i.AUDIO_FILE:
        return this.serializeAsAudioFile(t);
      case i.BUTTON:
        return this.serializeAsButton(t);
      case i.HORIZONTAL_RULE:
        return this.serializeAsHorizontalRule(t);
      case i.MESSENGER_CARD:
        return this.serializeAsMessengerCard(t);
      case i.TABLE:
        return this.serializeAsTable(t);
      case i.ORDERED_NESTED_LIST:
      case i.UNORDERED_NESTED_LIST:
        return this.serializeAsNestedList(t);
      case i.HTML:
        return this.serializeHtmlBlock(t);
      case i.TWITTER_FOLLOW_BUTTON:
        return this.serializeTwitterFollowButton(t);
      case i.FACEBOOK_LIKE_BUTTON:
        return this.serializeFacebookLikeButton(t);
      case i.SOCIAL:
        return this.serializeAsSocial(t);
      case i.SPACER:
        return this.serializeAsSpacer(t);
      case i.CALLOUT:
        return this.serializeCallout(t);
      case i.COLLAPSIBLE_SECTION:
        return this.serializeAsCollapsibleSection(t);
      case i.UNSUPPORTED_ELEMENT:
        return this.serializeAsUnsupportedElement(t);
    }
  }
  serializeTwitterFollowButton(t) {
    return {
      type: t.attrs.type,
      username: t.attrs.username
    };
  }
  serializeFacebookLikeButton(t) {
    return {
      type: t.attrs.type,
      url: t.attrs.url
    };
  }
  isHeadingBlock(t) {
    return t.type === "heading" || t.type === "subheading" || t.type === "subheading3" || t.type === "subheading4";
  }
  serializeTextBlock(t) {
    let e = { type: t.attrs.type, text: "" };
    return this.addAlignment(e, t), this.addStyle(e, t), e.type === "paragraph" && this.config.allowEmptyParagraphs && (e.allowEmpty = !0), e.type === "paragraph" && !this.config.allowImplicitMarginParagraphs && (e.class = m), e.text = new n(this.schema, this.config).serializeNode(t), this.isHeadingBlock(e) && (e.idAttribute = t.attrs.idAttribute), e;
  }
  serializeHtmlBlock(t) {
    let e = {
      type: t.attrs.type,
      content: "",
      header: null,
      footer: null
    };
    return e.content = t.attrs.content || "", e;
  }
  serializeIfElseStatement(t) {
    return {
      type: t.attrs.type,
      fallbackBlocks: t.attrs.fallbackBlocks,
      predicatesBlocksPairs: t.attrs.predicatesBlocksPairs
    };
  }
  serializeAsImage(t) {
    let e = { type: t.attrs.type, url: "" };
    return this.addAlignment(e, t), e.url = t.attrs.src, t.attrs.linkUrl && (e.linkUrl = t.attrs.linkUrl), t.attrs.width && (e.width = Number(t.attrs.width)), t.attrs.height && (e.height = Number(t.attrs.height)), t.attrs.displayWidth && (e.displayWidth = Number(t.attrs.displayWidth)), t.attrs.text && (e.text = t.attrs.text), e;
  }
  serializeAsImageText(t) {
    var s, r, a;
    return {
      type: t.attrs.type,
      imageUrl: ((s = t.attrs) == null ? void 0 : s.imageUrl) || "",
      title: (r = t.attrs) == null ? void 0 : r.title,
      text: (a = t.attrs) == null ? void 0 : a.text
    };
  }
  serializeAsList(t) {
    let e = { type: t.attrs.type, items: [] };
    return this.addStyle(e, t), t.content.forEach((s) => {
      e.items.push(
        new n(this.schema).serializeNode(s.content.firstChild)
      );
    }), e;
  }
  serializeAsNestedList(t) {
    let e = [];
    return t.content.forEach((s) => {
      e.push(this.serializeAsNestedListItem(s));
    }), {
      type: t.attrs.type,
      items: e
    };
  }
  serializeAsNestedListItem(t) {
    let e = [];
    return t.content.forEach((s) => {
      let r = this.serializeBlock(s);
      r && e.push(r);
    }), { content: e };
  }
  serializeAsVideo(t) {
    return {
      type: t.attrs.type,
      provider: t.attrs.provider,
      id: t.attrs.id
    };
  }
  serializeAsVideoFile(t) {
    return {
      type: t.attrs.type,
      thumbnailUrl: t.attrs.thumbnailUrl,
      url: t.attrs.url,
      captions: t.attrs.captions
    };
  }
  serializeAsAudioFile(t) {
    return {
      type: t.attrs.type,
      url: t.attrs.url
    };
  }
  serializeAsButton(t) {
    let e = f(t.attrs.text);
    e = e.replace(/&quot;/g, '"');
    let s = {
      type: t.attrs.type,
      text: e,
      linkUrl: t.attrs.linkUrl,
      buttonStyle: t.attrs.buttonStyle
    };
    return this.addAlignment(s, t), this.addStyle(s, t), this.addPadding(s, t), s;
  }
  serializeAsHorizontalRule(t) {
    let e = {
      type: t.attrs.type,
      text: z
    };
    return this.addNodeWidth(e, t), this.addBorderStyles(e, t), e;
  }
  serializeAsMessengerCard(t) {
    return {
      type: "messengerCard",
      canvas: t.attrs.canvas,
      text: t.attrs.text,
      messenger_app_id: t.attrs.messenger_app_id,
      uri: t.attrs.uri
    };
  }
  serializeAsTable(t) {
    let e = [], s = t.attrs.container, r = t.attrs.responsive;
    t.content.forEach((l) => {
      e.push(this.serializeAsTableRow(l, s));
    });
    let a = {
      type: t.attrs.type,
      responsive: t.attrs.responsive,
      container: s,
      rows: e
    };
    return typeof t.attrs.stacked == "boolean" && (a.stacked = t.attrs.stacked), (s || r) && (this.addStyle(a, t), this.addPadding(a, t)), t.attrs.sectionType && (a.sectionType = t.attrs.sectionType), a;
  }
  serializeAsTableRow(t, e) {
    let s = [];
    return t.content.forEach((r) => {
      s.push(this.serializeAsTableCell(r, e));
    }), { cells: s };
  }
  serializeAsTableCell(t, e) {
    var a;
    let s = [];
    t.content.forEach((l) => {
      let c = this.serializeBlock(l);
      c && s.push(c);
    });
    let r = { content: s };
    return e && this.addPadding(r, t), !e && !t.attrs.responsive && this.addBackgroundColor(r, t), ((a = t.attrs.colwidth) == null ? void 0 : a.length) > 0 && (r.displayWidth = t.attrs.colwidth[0]), r;
  }
  serializeAsSocial(t) {
    let e = {
      type: t.attrs.type,
      items: t.attrs.items
    };
    return this.addAlignment(e, t), e;
  }
  serializeAsSpacer(t) {
    return {
      type: t.attrs.type,
      height: t.attrs.height
    };
  }
  serializeCallout(t) {
    let e = [];
    return t.content.forEach((s) => {
      let r = this.serializeBlock(s);
      r && e.push(r);
    }), {
      type: t.attrs.type,
      content: e,
      style: {
        backgroundColor: t.attrs.backgroundColor,
        borderColor: t.attrs.borderColor
      }
    };
  }
  serializeAsUnsupportedElement(t) {
    return {
      type: t.attrs.type,
      unsupportedTypeName: t.attrs.unsupportedTypeName,
      text: t.attrs.text,
      category: "unsupported"
    };
  }
  serializeAsCollapsibleSection(t) {
    let e, s = [];
    return t.content.forEach((r) => {
      r.attrs.type === i.COLLAPSIBLE_SECTION_SUMMARY ? e = this.serializeCollapsibleSectionSummary(r) : r.attrs.type === i.COLLAPSIBLE_SECTION_CONTENT && (s = this.serializeCollapsibleSectionContent(r));
    }), {
      type: t.attrs.type,
      summary: e,
      content: s
    };
  }
  serializeCollapsibleSectionSummary(t) {
    let e = {
      type: "paragraph",
      text: ""
    }, s;
    return t.content.firstChild && (s = this.serializeBlock(t.content.firstChild)), s || e;
  }
  serializeCollapsibleSectionContent(t) {
    let e = [];
    return t.content.forEach((s) => {
      let r = this.serializeBlock(s);
      r && e.push(r);
    }), e;
  }
  addAlignment(t, e) {
    let s = e.attrs.alignment;
    s && s !== A && (t.align = s);
  }
  addNodeWidth(t, e) {
    let s = e.attrs.width;
    s && (t.width = s);
  }
  addBackgroundColor(t, e) {
    let s = e.attrs.backgroundColor;
    s && (t.style = {
      ...t.style,
      backgroundColor: s
    });
  }
  addBorderStyles(t, e) {
    var s;
    if ((s = this.config.customStylesConfig) != null && s.allowCustomStyles) {
      let { borderColor: r, borderStyle: a, borderWidth: l } = e.attrs;
      (r || a || l) && (t.style = {
        ...t.style,
        ...r && { borderColor: r },
        ...a && { borderStyle: a },
        ...l && { borderWidth: l }
      });
    }
  }
  addStyle(t, e) {
    var s;
    if ((s = this.config.customStylesConfig) != null && s.allowCustomStyles) {
      let { fontFamily: r, fontColor: a, backgroundColor: l, borderRadius: c } = e.attrs;
      (r || a || l || c) && (t.style = {
        ...t.style,
        ...r && { fontFamily: r },
        ...a && { fontColor: a },
        ...l && { backgroundColor: l },
        ...c && { borderRadius: c }
      });
    }
  }
  addPadding(t, e) {
    var s;
    if ((s = this.config.customStylesConfig) != null && s.allowCustomStyles) {
      let { paddingTop: r, paddingBottom: a, paddingLeft: l, paddingRight: c } = e.attrs;
      (r || a || l || c) && (t.style = {
        ...t.style,
        ...r && { paddingTop: r },
        ...a && { paddingBottom: a },
        ...l && { paddingLeft: l },
        ...c && { paddingRight: c }
      });
    }
  }
  isIncompleteUpload(t) {
    return t.startsWith("blob");
  }
}
export {
  C as BlocksSerializer
};
